import React, { useState, useEffect } from "react";
import Message from "../Message/message";
import "./messages.css";
//import { css } from 'glamor';
import ScrollToBottom from "react-scroll-to-bottom";

const Messages = ({ messages, name , room, otherusername }) => {
	const [scroll, setScroll] = useState("")
	const getAdminText = messages.filter(
		(message, i) => message.user === "admin"
	); //get all the admin messages from all the messages sent
	const getAdminLastMessage = getAdminText.map((message, i) => message.text); //getting the text that was sent by the admin
	const getAdminLastTextMessage = getAdminLastMessage
		.splice(-1, 1)
		.toString(); //getting the new text that was sent by the adming
		useEffect(()=>{
			const a= document.querySelector("#scroll")
		a.scrollTop = a.scrollHeight;
		setScroll(a.scrollHeight)
		a.scrollTop = scroll;
		},[messages])

	return (
		<div className="ScrollToBottom" id="scroll">
		 <p className="firstmessage">Web Chat application created by Moses Benjamin</p>
			<div className="allmessage">
			{messages.map((message, i) => (
				<Message message={message} name={name} otherusername={otherusername} room={room} key={i} />
			))}
			</div>
		</div>
	);
};
export default Messages;
